// extracted by css-extract-rspack-plugin
export default {"root":"root-H2Q6sG"};